import { useQuery } from "@tanstack/react-query";

import ProductService from "services/Product";

const toOption = product => ({
  key: product.id,
  value: product.id,
  text: product.name,
});

const loadInvoiceProducts = async savedProductIds => {
  const products = await ProductService.getForFilters();
  const enabledIds = new Set(products.map(product => product.id));
  const missingIds = [...new Set(savedProductIds)].filter(
    id => !enabledIds.has(id)
  );
  // A product the record still references but the catalog no longer offers is
  // disabled; it is fetched by id so its line can still show its name.
  const disabledProducts = await Promise.all(
    missingIds.map(id => ProductService.get(id))
  );
  return {
    productOptions: products.map(toOption),
    disabledProductOptions: disabledProducts.map(product => ({
      ...toOption(product),
      text: `${product.name} (Disabled)`,
    })),
    disabledProductIds: new Set(missingIds),
  };
};

/** The catalog products for invoice lines, plus the disabled ones in use. */
export const useInvoiceProducts = (invoices = [], { enabled = true } = {}) => {
  const savedProductIds = invoices
    .map(invoice => invoice.product_id)
    .filter(id => typeof id === "number")
    .sort((a, b) => a - b);

  return useQuery({
    queryKey: ["revenue-opportunity-invoice-products", savedProductIds],
    queryFn: () => loadInvoiceProducts(savedProductIds),
    enabled,
  });
};
